import { render, staticRenderFns } from "./MarketOverall.vue?vue&type=template&id=1fcadff6"
import script from "./MarketOverall.vue?vue&type=script&lang=js"
export * from "./MarketOverall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports